import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSDMEQuotation, updateSDMEQuotation } from 'src/_helpers/api';

const name = 'sdmeQuotations';

const initialState = {
  quotations: [],
  error: null,
};

const addSDMEQuotationAsync = createAsyncThunk(

	`${name}/add-sdme-quotation`,
	async (quotationData) => {
		//console.log("Inside addSDMEQuotationAsync")
		// prendre la date d'aujourd'hui avec le bon format au lieu du formattage de JS pour le .json
		const monthNames = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin",
			"Juillet", "Aout", "Sep", "Oct", "Nov", "Dec"
		];
		const today = new Date();
		const day = `${today.getDate() < 10 ? "0" : ""}${today.getDate()}`;
		const year = today.getFullYear();
		const hours = today.getHours();
		const minutes = today.getMinutes();

		const formattedDate = `${day}/${monthNames[today.getMonth()]}/${year} ${hours}:${minutes}`;

		console.log("slice quotationData: ", quotationData)

		// Construire l'objet commun pour la création ou la mise à jour
		const apiDataCommon = {
			AirFlowType: quotationData.airFlowType,
			CancelPrecedentVersion: quotationData.cancelPrecedentVersion,
			CFMHighVolume: quotationData.CFMHighVolume,
			CFMMinVolume: quotationData.CFMMinVolume,
			City:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.city
					: null,
			ContactName: quotationData.contactName || null,
			Controls: quotationData.controls,
			Country:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.country
					: null,
			Customer: quotationData.customer || "",
			DirtyFilterContact: quotationData.dirtyFilterContact,
			DischargeLocation: quotationData.dischargeLocation,
			DisconnectSwitch: quotationData.disconnectSwitch,
			AdjustablePrePurge: quotationData.adjustablePrePurge,
			DoubleReversedInterlock: quotationData.doubleReversedInterlock,
			ExternalStaticPressure: quotationData.externalStaticPressure,
			GasTrainType: quotationData.gasTrainType,
			GasType: quotationData.gasType,
			Installation: quotationData.installation,
			Margin: quotationData.margin,
			MotorSecurityFactor: quotationData.motorSecurityFactor,
			NumberUnits: quotationData.numberUnits,
			OAEADamper: quotationData.oaeaDamper,
			ProductName: quotationData.productName,
			Product_id: quotationData.product_id,
			ProjectName: quotationData.projectName,
			ProjectNumber: quotationData.projectNumber,
			Province:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.province
					: null,
			QuotationStatus: quotationData.quotationStatus,
			QuoteDate: formattedDate,
			Representative: quotationData.representative || null,
			RoomOverrideStat: quotationData.roomOverrideStat,
			Shipping: quotationData.shipping,
			StartUp: quotationData.startUp,
			LeadTime: quotationData.leadTime,
			SubmittedBy: quotationData.submittedBy,
			TemperatureRise: quotationData.temperatureRise,
			Template_id: quotationData.template_id,
			UnitDesignation: quotationData.unitDesignation,
			UserId: quotationData.UserId,
			Voltage: quotationData.voltage,
		};

		console.log("slice apiDataCommon: ", apiDataCommon)

		// Vérifier si on est en "création" ou en "révision"
		let response;
		if (quotationData.id) {

			//console.log("quotationData.id is defined: ", quotationData.id)

			const apiDataForUpdate = {
				SDMEQuoteCode: quotationData.quote,
				...apiDataCommon,
			};
			response = await updateSDMEQuotation(apiDataForUpdate);
		} else {

			response = await createSDMEQuotation(apiDataCommon);
		}

		return response;
	}
);

const sdmeQuotationSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.quotations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSDMEQuotationAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSDMEQuotationAsync.fulfilled, (state, action) => {
        state.quotations = action.payload;
      })
      .addCase(addSDMEQuotationAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const sdmeQuotationActions = {
  ...sdmeQuotationSlice.actions,
  addSDMEQuotationAsync,
};

export const sdmeQuotationsReducer = sdmeQuotationSlice.reducer;


